import React from 'react';
import ReactDOM from 'react-dom';
import PlotEquation from './App';
import './index.css'

ReactDOM.render(
  <React.StrictMode>
    <PlotEquation />
  </React.StrictMode>,
  document.getElementById('root')
);
